import { css } from '@inter-ikea-kompis/web-component';
export default class AssemblyServicesStyle {
    static getStyle(options) {
        const { spacing, color } = options.theme;
        // Using small as breakpoint since fontStyle is the same for all of theme
        const { headingSmall, bodyMedium } = options.theme.breakpoint.small.fontStyle;
        return css `
			:host {
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				gap: ${spacing.space100 / 16}rem;

				width: 100%;
				padding: ${spacing.space100 / 16}rem;
				border: ${1 / 16}rem solid ${color.neutral.grey500};
				border-radius: ${6 / 16}rem;
			}

			h4 {
				font-weight: ${headingSmall.weight ?? ''};
				font-size: ${headingSmall.size / 16}rem;
				line-height: ${headingSmall.lineHeight / 16}rem;
				color: ${color.neutral.grey900};
				margin: 0;
			}

			p {
				color: ${color.neutral.grey700};
				margin: 0;
			}

			p,
			a {
				line-height: ${bodyMedium.lineHeight / 16}rem;
				font-size: ${bodyMedium.size / 16}rem;
			}

			a {
				display: inline-block;
				overflow: overlay;
			}

			a,
			kompis-assembly-services-status-button {
				margin-top: ${spacing.space75 / 16}rem;
			}

			skapa-icon {
				color: ${color.text.dark};
				flex-shrink: 0;
			}
		`;
    }
}
//# sourceMappingURL=AssemblyServicesStyle.js.map